<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
    &copy; 2018, 8bit Solutions LLC
    <br> {{'versionNumber' | i18n : version}}
</div>
